<template>
  <v-app class="device-register" :class="color">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex d-flex xs12 sm12 md8>
                <v-card class="elevation-5">
                    <v-img                        
                        :src="require('@/assets/img/bg/frcground.jpg')"
                        aspect-ratio="2.0"
                    >
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                              <v-flex xs12 align-center flexbox>
                                <span class="display-3" style="float:right">Biz 4 Accounting</span>
                              </v-flex>
                            </v-layout>
                        </v-container>
                    </v-img>
                    
                    <v-card-text class="pa-0">          
                        <v-tabs  v-model="selectedTab">
                            <v-tab ripple href="#tab-1">
                              Information
                            </v-tab>
                            <v-tab ripple href="#tab-2">
                              Licence & Aggrement
                            </v-tab>
                            <v-tabs-items v-model="selectedTab">
                              <v-tab-item value="tab-1">
                                 <v-card flat>
                                  <v-card-text>
                                      {{ lorem.slice(0, 140) }}
                                      {{ lorem.slice(0, 140) }}
                                      {{ lorem.slice(0, 140) }}
                                      {{ lorem.slice(0, 140) }}
                                      {{ lorem.slice(0, 140) }}
                                      {{ lorem.slice(0, 140) }}
                                      {{ lorem.slice(0, 140) }}
                                      {{cardText}}
                                  </v-card-text>
                                </v-card>
                              </v-tab-item>
                              <v-tab-item value="tab-2">
                                <v-card flat>
                                  <v-card-text>
                                      {{ lorem.slice(0, 940) }}
                                      {{ lorem.slice(0, 940) }}
                                      {{ lorem.slice(0, 940) }}
                                      {{ lorem.slice(0, 940) }}
                                      {{ lorem.slice(0, 940) }}
                                      {{ lorem.slice(0, 940) }}
                                      {{ lorem.slice(0, 940) }}
                                      {{ lorem.slice(0, 940) }}
                                      {{ lorem.slice(0, 940) }}
                                  </v-card-text>
                                </v-card>
                              </v-tab-item>              
                            </v-tabs-items>
                        </v-tabs>                
                    </v-card-text>
                </v-card>                            
            </v-flex>            
            <v-flex xs12 sm12 md4>              
                <v-card class="pa-3 elevation-5" >
                  <v-card-text>
                    <div class="layout column align-center">
                      <img src="@/assets/img/m.png" alt="Vue Material Admin" width="120" height="120">
                      <h1 class="flex my-4 primary--text">Device Register</h1>                  
                    </div>                
                    <v-form>
                      <v-text-field append-icon="fa fa-at fa-lg" name="email" label="email" type="text" v-model="model.email"></v-text-field>
                      
                      <v-text-field append-icon="fa fa-building fa-lg" name="company" label="company" type="text" v-model="model.company"></v-text-field>
                      <v-textarea
                        name="token"
                        append-icon="fa fa-500px fa-lg"
                        label="CID Register Token"
                        v-model="model.token"
                        hint="Hint text"
                      ></v-textarea>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>  
                    <v-btn icon ripple @click="openSetting">
                        <v-icon color="teal">fa-gear</v-icon>
                    </v-btn>    
                                          
                    <v-spacer></v-spacer>
                    <v-btn block color="primary" @click="register" :loading="loading">Register This Device</v-btn>
                  </v-card-actions>
                </v-card>
            </v-flex>           
        </v-layout>
      </v-container>
    
      <widget-dialog-setting></widget-dialog-setting>
  </v-app>
</template>

<script>
import config from '@/config';  
import WidgetDialogSetting from '../components/widgets/DialogSetting';    
import AppSnackbar from '../components/app/Snackbar';
import Device from '@/util/models/Device';  



const assets = require.context('@/assets/');
export default {
  components: {
    AppSnackbar,
    WidgetDialogSetting 
  },      
  data () {
    return {
      color:config.color, 
        selectedTab: null,
        loading: false,
        model: {
          email: 'admin@sangkilsoft.com',
          password: 'password',
          company: 'SangkilSoft .Inc',
          token:'5b599433f34ae'
        },
        snackbar : AppSnackbar,
        image : '',
        show: true,
        cardText: 'Hey there, I am a very simple card. I am good at containing small bits of information. I am quite convenient because I require little markup to use effectively.',
        lorem: `Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.`,        
    };
  },
  computed: {
    computeImage(gambar) {
      return assets('./bg/accounting.jpg');
    },
  },
  methods: {    
    async register() {
        this.loading = true;
        const response = await Device.register();        
        if(response.status == 200){        
            this.token = response.data;
            Device.set(this.token);            
            window.getApp.$emit('showSnackbar', {
                show:true,
                text:'Register Succesfully. Welcome to Biz 4 Accounting. ',
                color:'green'
            });
        
            setTimeout(() => {this.$router.push('/login');}, 1000);
        } else {
            var msg = response.data? '#'+response.data.status+' => '+response.data.message:
                'Something happened in setting up the request that triggered an Error.'; 
            
            window.getApp.$emit('showSnackbar', {
                show:true,
                text: msg,
                color:'red'
            });
        }
        setTimeout(() => {this.loading = false;}, 1000);
    },
    
    openSetting(){
        window.getApp.$emit('APP_OPEN_DIALOG_SETTING');        
    }
  }

};
</script>
<style scoped lang="css">
  .device-register {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
